import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {useParams} from "react-router-dom";
import {baseUrl, ipAddress, userName} from "../Univ";
function WorkerAttendance() {
    const {assignmentId} = useParams();
    const [attendance, setAttendance] = useState([]);
    const [loading, setLoading] = useState(false);
    // ---------------- FETCH ATTENDANCE ----------------
    const fetchAttendance = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                baseUrl + "attendance-assignment/" + assignmentId + "/"
            );
            setAttendance(res.data);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchAttendance();
    }, [assignmentId]);
    // ---------------- MARK ATTENDANCE ----------------
    const markAttendance = async () => {
        const today = new Date().toISOString().split("T")[0];
        const alreadyMarked = attendance.some(
            a => a.attendance_date === today
        );
        if (alreadyMarked) {
            Swal.fire(
                "Warning",
                "Today's attendance already marked",
                "warning"
            );
            return;
        }
        const fd = new FormData();
        fd.append("assignment", assignmentId);
        fd.append("attendance_date", today);
        fd.append("worker_marked", true);
        fd.append("owner_verified", false);
        fd.append("status", 1);
        fd.append("addedby", userName);
        fd.append("ip_add", ipAddress);
        try {
            await axios.post(
                baseUrl + "attendance/",
                fd
            );
            Swal.fire(
                "Success",
                "Attendance marked successfully",
                "success"
            );
            fetchAttendance();
        } catch (err) {
            console.log(err.response?.data);
            Swal.fire(
                "Error",
                "Unable to mark attendance",
                "error"
            );
        }
    };
    return (
        <section className="container mt-4">

            <div className="d-flex justify-content-between mb-3">

                <h3>
                    Attendance
                </h3>

                <button
                    className="btn btn-primary"
                    onClick={markAttendance}
                >
                    Mark Today's Attendance
                </button>

            </div>

            {loading && (
                <div className="alert alert-info">

                    Loading Attendance...

                </div>
            )}

            {!loading && attendance.length === 0 && (
                <div className="alert alert-warning">

                    No Attendance Found

                </div>
            )}

            <div className="card">

                <div className="card-body">

                    <table className="erp-table-modern">

                        <thead>

                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>

                            <th>Date</th>
                            <th>Worker Marked</th>
                            <th>Owner Verified</th>
                            <th>Verified Time</th>
                            <th>Remarks</th>

                        </tr>

                        </thead>

                        <tbody>

                        {attendance.map((row) => (
                            <tr key={row.id}>

                                <td>
                                    {row.attendance_date}
                                </td>

                                <td>

                                    {row.worker_marked ? (
                                        <span className="badge bg-success">
                        YES
                      </span>
                                    ) : (
                                        <span className="badge bg-danger">
                        NO
                      </span>
                                    )}

                                </td>

                                <td>

                                    {row.owner_verified ? (
                                        <span className="badge bg-success">
                        VERIFIED
                      </span>
                                    ) : (
                                        <span className="badge bg-warning">
                        PENDING
                      </span>
                                    )}

                                </td>

                                <td>
                                    {row.owner_verified_time || "-"}
                                </td>

                                <td>
                                    {row.remarks || "-"}
                                </td>

                            </tr>
                        ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </section>
    );
}
export default WorkerAttendance;